import React from 'react';
import { Text, Tooltip } from '@chakra-ui/react';

export const Required = () => {
    return (
        <Tooltip label="Este campo es requerido" aria-label="A tooltip">
            <Text as="span" marginLeft="s" color="red.500">*</Text>
        </Tooltip>
    );
};
